export const tsupales = {
  id: "tsupales",
  link: "/#/recipes/recipes/tsupales",
  name: "Tsupales",
  cuisine: "Herdazian",
  summary:
    "Shrimp filled corn pouches, like something halfway between an empanada and a tamal",
  inspiration: "Empanadas, Tamales",
  quantity: "16 tsupales",
  time: "1 hour",
  notes:
    "As I read about Elhokar and Isa making tsupales, I was taken back to memories of mountains of tamales during the holidays. Spending hours in the kitchen, making endless amounts of them for family and friends, it felt very culturally similar. The actual description of the tsupale, though, is a bit closer to an empanada. I followed the instructions in the story as closely as possible, but decided to serve it with avocado. We never see them eaten in the story, so we don't know how they're served, and the creaminess of the avocado goes really well with the masa of the tsupale.",
  quotes:
    '"It takes work," said Isa. "Just like rolling tsupales"... Elhokar returned to his current tsupale and folded it as best he could. (King Lopen the First of Alethkar)',
  image: "https://jozomby-public.s3.amazonaws.com/recipes/tsupales-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "groundShrimp",
          display: "1/2 lb uncooked shrimp without shells"
        },
        {
          item: "coriander",
          display: "1/4 tsp ground coriander"
        },
        {
          item: "cumin",
          display: "1/4 tsp ground cumin"
        },
        {
          item: "salt",
          display: "3/4 tsp salt, divided"
        },
        {
          item: "lemon",
          display: "1/2 tsp lemon juice"
        },
        {
          item: "onion",
          display: "1/4 onion"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic"
        },
        {
          item: "ginger",
          display: "1/2 inch ginger"
        },
        {
          item: "vegetableOil",
          display: "1 tbsp vegetable oil"
        },
        {
          item: "bellPepper",
          display: "1/2 red bell pepper"
        },
        {
          item: "maseca",
          display: "3 cups Mexican-style corn flour (Maseca)"
        },
        {
          item: "eggs",
          display: "4 eggs"
        },
        {
          item: "water",
          display: "1 cup water"
        },
        {
          item: "avocado",
          display: "4 avocados"
        }
      ]
    }
  ],
  steps: [
    "In a food processor, combine the shrimp, coriander, cumin, 1/2 tsp of the salt, lemon juice, onion, garlic, ginger, and vegetable oil. Process until it forms a paste. Mince the bell pepper and mix it into the paste with a spoon.",
    "For the dough, combine the maseca, eggs, water, and remaining 1/4 tsp salt in a large bowl. Mix well, then knead into a ball. Separate into 16 balls.",
    "Preheat oven to 350 degrees Fahrenheit. Work one ball at a time. If the dough starts getting dry, moisten your hands with a bit of water then knead the dough a bit. Press the dough ball with a lined tortilla press to a 5 inch disk. If you do not have a tortilla press, take a plastic shopping bag and slit it along the sides so it will lay flat. Place the dough ball on top and fold the bag over to cover. Roll the ball out with a rolling pin to 5 inches in diameter.",
    "Place 1 tbsp of filling in the disk just below the center, spreading it out into a horizontal line that starts and ends about an inch from each side. Fold the sides of the disk in over the filling. Fold the bottom of the disk up. Roll the bundle over to complete the package, and trim off any extra dough. Lay it seam-side down on a baking sheet. Gently crimp both ends with a fork. The dough is fragile and this entire process is tricky, so it may take a few tries to get it right.",
    "Once all 16 tsupales are formed and on the baking sheet, bake for 15 minutes. Slice the avocados and serve the tsupales topped with avocado."
  ]
}
